module.exports = __webpack_public_path__ + "static/media/LE.df84beda.png";